// extracted by mini-css-extract-plugin
export default {"component":"SectionTitle_component__ZEDAR","value":"SectionTitle_value__5c841","children":"SectionTitle_children__TTRhs"};